<template>
  <div id="listItem">
    <div class="listItem">
      <div @click="isDone">
        <slot name="left">
          <div class="rotate">
            <svg v-if="!done" class="icon iconCenter" aria-hidden="true"><use xlink:href="#icon-weiwancheng-"></use></svg>
            <svg v-else class="icon iconCenter" aria-hidden="true"><use xlink:href="#icon-yiwancheng-""></use></svg>              
          </div>
        </slot>        
      </div>
      <div @click="copyItem" class=" maxcontent">      
        <slot name="center">
          <span v-if="done" class="center">{{item}}</span>
          <span v-else class="maxcontent">{{item}}</span>                
        </slot>
      </div>
      <div @click="deleteItem">
        <slot name="right">
          <div class="rotate">
            <svg v-if="!done" class="icon iconCenter" aria-hidden="true"><use xlink:href="#icon-shanchu1"></use></svg>
            <svg v-else class="icon iconCenter" aria-hidden="true"><use xlink:href="#icon-shanchu"></use></svg> 
          </div>    
        </slot>        
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ListItem",
    data() {
      return {
      }
    },
    props: {
      done: {
        type: Boolean,
        default: false,
      },
      item: String
    },
    methods: {
      isDone() {
        this.$emit('isDone')
      },
      deleteItem() {
        this.$emit('deleteItem')
      },
      copyItem() {
        this.$emit('copyItem')
      }
    }
  }
</script>

<style lang="less" scoped>
 .listItem {
    height: 0.2875rem;
    width: 99%;
    line-height: 0.2875rem;
    margin-bottom: 0.125rem;
    display: flex;

    border-radius: 0.125rem;
    background-color: @item-bgc;
    box-shadow:@itemBoxShadow;
  }
  //字体图标
  .icon {
    width: 1.5em;
    height: 1.5em;
    vertical-align: -0.4em;
    fill: currentColor;
    overflow: hidden;
    padding-left: 0.1875rem;
    cursor: pointer;
  }
  .iconCenter {
    width: 1.4em;
    height: 1.4em;
    // vertical-align: 1.3rem;
    padding-top: 0.056rem;
    padding-right: 0.1875rem;
  }
  .center {
    text-decoration: line-through;
    color: #7A7A7A;
  }
  .maxcontent {
    flex: 1;
    overflow: hidden;
  }
  .rotate {
    transition: .3s;
    &:hover {
      transform: rotate(360deg);
    }
  }
</style>